import { createContext } from 'react'

import type { ChartPrintContextData } from './types'

export const ChartPrintContext = createContext<ChartPrintContextData>({
  setChartsConfig: () => {},
  getPrint: () => {},
  isPrinting: false,
})
